import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setLogOut, setUser } from "../Reducer/UserSlice";
import { setOpenChoiceSystem, setOpenLogin } from "../Reducer/ModalSlice";

function Login() {
    const Server = useSelector(state => state.UserSlice.Server)
    const LogOut = useSelector(state => state.UserSlice.LogOut)

    const [Email, setEmail] = useState()
    const [Password, setPassword] = useState()
    const [RememberMe, setRememberMe] = useState()
    const [CancelTouch, setCancelTouch] = useState(false)

    const dispatch = useDispatch()

    useEffect(() => {
        var EmailLocal = localStorage.getItem('Email')
        var PasswordLocal = localStorage.getItem('Password')
        var RememberMeLocal = localStorage.getItem('RememberMe')
        
        const getRemembder = async () => {
            await setEmail(EmailLocal)
            await setPassword(PasswordLocal)
            if(RememberMeLocal === 'true')
            {
                await setRememberMe(true)
                if(!LogOut)
                await axios.post(Server + 'auth/local', {
                    identifier: EmailLocal,
                    password: PasswordLocal
                })
                .then(async (response) => {
                    await dispatch(setUser(response.data))
                    dispatch(setOpenLogin(false))
                    await dispatch(setOpenChoiceSystem(true))
                    localStorage.setItem('RememberMe', true)
                    localStorage.setItem('Email', EmailLocal)
                    localStorage.setItem('Password', PasswordLocal)
                })
            }
        }

        getRemembder();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleLogin = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()

        axios.post(Server + 'auth/local', {
            identifier: Email,
            password: Password
        })
        .then(async (response) => {
            
            await dispatch(setUser(response.data))
            dispatch(setOpenLogin(false))
            dispatch(setLogOut(false))
            await dispatch(setOpenChoiceSystem(true))
            if(RememberMe)
            {
                localStorage.setItem('RememberMe', true)
                localStorage.setItem('Email', Email)
                localStorage.setItem('Password', Password)
            }
            else
            {
                localStorage.clear()
            }
        })
        .catch(() => {
            alert('Введенные данные не верны')
        })
    }

    return(
        <div
        className="LoginGlobalDiv"
        >
            <div
            className="LoginModalMainDiv"
            >
                <div
                className="LoginLogoDiv"
                />

                <div
                className="LoginTextDiv"
                >
                    Вход в систему
                </div>          

                    <div
                    className="InputLoginDiv"
                    >
                        <div
                        className="InputLoginTextDiv"
                        >
                            Email:
                        </div>

                        <input
                        className="InputLogin"
                        id='InputLogin Email'
                        value={Email}
                        onChange={((e) => {
                            setEmail(e.target.value)
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={(() => {
                            if(!CancelTouch)
                                document.getElementById('InputLogin Email').focus()
                        })}
                        />

                    </div>

                    <div
                    className="InputLoginDiv"
                    >
                        <div
                        className="InputLoginTextDiv"
                        >
                            Пароль: 
                        </div>
                        
                        <input
                        className="InputLogin"
                        id='InputLogin Password'
                        value={Password}
                        type="password"
                        onChange={((e) => {
                            setPassword(e.target.value)
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={(() => {
                            if(!CancelTouch)
                                document.getElementById('InputLogin Password').focus()
                        })}
                        />

                    </div>
                    

                    <div
                    className="LoginRemember"
                    onClick={(() => {
                        setRememberMe(!RememberMe)
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                            setRememberMe(!RememberMe)
                    })}
                    >
                        <input
                        type="checkbox"
                        checked={RememberMe}
                        />
                            Запомнить меня
                    </div>

                    <button
                    className="LoginButton"
                    onClick={handleLogin}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                            handleLogin(event)
                    }}
                    >
                        Войти
                    </button>
            </div>
        </div>
    )
}

export default Login;
